module.exports = __webpack_public_path__ + "img/wawa2_slide_2.a661be8b.jpg";